<script>
    export let size = 'lg';
    export let disabled = false;
    export let topRight = false;
    export let dark = false;
</script>

<button class="close-button size-{size}" class:display-absolute={ topRight } class:dark on:click
        class:disabled={ disabled }>
    <span>&times;</span>
</button>

<style>
    .close-button {
        position: relative;
        width: 25px;
        height: 25px;
        color: #d2d2d2;
    }

    .close-button.size-lg {
        font-size: 1.5rem;
    }

    .close-button.size-xl {
        font-size: 2rem;
    }

    .close-button:hover {
        color: #bcbcbc;
    }

    .close-button.dark {
        color: #333333;
    }

    .close-button.disabled {
        color: #e5e5e5;
    }

    .display-absolute {
        position: absolute;
        top: 15px;
        right: 15px;
    }

    .close-button span {
        position: absolute;
        top: -9px;
        left: 4px;
    }

    .close-button.size-xl span {
        top: -14px;
        left: 2px;
    }
</style>